export const LABELS = {
  archivedDescription: 'Archived in project:',
  archivedError: 'Issue could not be restored in project',
  archivedSuccess: 'Issue restored in project',
  emptySections: {
    labels: 'No labels',
    assignees: (viewerCanAssign: boolean) => (viewerCanAssign ? 'No one - ' : 'No one assigned'),
    selfAssign: 'Assign yourself',
    milestones: 'No milestones',
    projects: 'No projects',
    status: 'No status',
    noValue: (fieldName: string) => `No ${fieldName.toLowerCase()}`,
    iterationPlaceholder: 'Choose an iteration',
    datePlaceholder: 'Choose a date',
    numberPlaceholder: 'Enter number…',
    iterationFilterPlaceholder: 'Filter options',
    singleSelectFilterPlaceholder: 'Filter options',
  },
  milestones: {
    noDueDate: 'No due date',
    dueOn: (dueDate: string) => {
      const dueOn = new Date(Date.parse(dueDate))
      return `Due on ${dueOn.toLocaleString('default', {month: 'short'})} ${dueOn.getDate()}`
    },
    progressPercentage: (progress: number) => (progress ? `, ${Math.round(progress)}% complete` : ', not started'),
  },
  sectionTitles: {
    assignees: 'Assignees',
    labels: 'Labels',
    milestones: 'Milestones',
    projects: 'Projects',
  },
  awaitingTriage: 'Awaiting triage',
  defaultProjectFieldName: 'Status',
  moveCardToColumn: 'Move card to column',
  selectProjects: 'Select projects',
  filterProjects: 'Filter projects',
  showClosedProjects: 'Show closed projects',
  showMoreProjectFields: 'Show more project fields',
}
